import { configureStore } from '@reduxjs/toolkit';
import uploadReducer from './slices/uploadSlice';
import authReducer from './slices/authSlice';
import customerAuthReducer from './slices/customerAuthSlice';

export const store = configureStore({
  reducer: {
    upload: uploadReducer,
    auth: authReducer,
    customerAuth: customerAuthReducer,
  },
  // SECURITY: Explicitly disable Redux DevTools in production to prevent
  // state history exposure on shared computers (Task #4210)
  devTools: process.env.NODE_ENV !== 'production',
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;